import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { PumpType } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  useMemo,
  forwardRef,
} from "react"

import {
  usePolyglot,
  useFollowedUsers,
} from "src/contexts"
import { followToSharerFirstAndLastInitial } from "src/utils"

const polyglotPrefix = "components.user_data."

export interface Props extends ComponentPropsWithoutRef<"div"> {
  pumpStatus?: PumpStatus;
}

/*
 * this renders a string like "User Name's data" or "User Name's t:slim X2"
 */
export const UserData = forwardRef<HTMLDivElement, Props>(
  function UserData(props: Props, propRef: Ref<HTMLDivElement>) {
    const polyglot = usePolyglot()
    const {
      pumpStatus,
      ...divProps
    } = props

    const pumpType: undefined | PumpType = pumpStatus?.pump_type
    const { currentFollow } = useFollowedUsers()

    const textString = useMemo(
      () => {
        // note that product names are intentionally not translated
        let pumpName = ""
        const userName = followToSharerFirstAndLastInitial(currentFollow)

        if (pumpType === PumpType.TSlim) {
          pumpName = "t:slim X2"
        }

        if (pumpType === PumpType.Mobi) {
          pumpName = "Mobi"
        }

        if (pumpName) {
          return polyglot.t(
            `${polyglotPrefix}with_pump_name`,
            {
              userName,
              pumpName,
            },
          )
        }

        return polyglot.t(
          `${polyglotPrefix}without_pump_name`,
          { userName },
        )
      },
      [
        pumpType,
        polyglot,
        currentFollow,
      ],
    )
    return (
      <div
        id="users-data"
        {...divProps}
        ref={propRef}
      >
        {textString}
      </div>
    )
  },
)
